import React, { MouseEvent } from 'react';

import css from './Tab.module.css';

export enum TabSize {
  normal = 'normal',
  large = 'large',
}

type ITabElement = React.HTMLAttributes<HTMLButtonElement>;

interface IProps {
  active?: boolean;
  size?: TabSize;
  controlsId?: string;
  id?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const Tab: React.FC<IProps & ITabElement> = ({
  children,
  active = false,
  size = TabSize.normal,
  controlsId,
  onClick,
  ...props
}) => {
  return (
    <button
      aria-selected={active}
      aria-controls={controlsId}
      role="tab"
      className={`${css.tab} mr-6 relative transition-all duration-300 before-focus-style`}
      data-testid="tab"
      data-size={size}
      data-active={String(active)}
      onClick={onClick}
      {...props}>
      {children}
    </button>
  );
};

export default Tab;
